import { useEffect } from 'react';
import CorralForm from '../../components/corrales/CorralForm';
import { useCorralesStore, type RegistrarCorral } from '../../stores/corrales/corrales.store';

const AgregarCorral = () => {
  const { current: corral, nuevo, registrar } = useCorralesStore();

  useEffect(() => {
    nuevo();
  }, []);

  const handleSave = (values: RegistrarCorral) => {
    return registrar(values);
  };

  return <CorralForm esAgregar={true} corral={corral} onSave={handleSave} />;
};

export default AgregarCorral;
